import Component from '../component/component';
import Helpers from '../helpers/helpers';
import Icon from '../icon/icon';
import QrScanner from '../qr-scanner/qr-scanner';

import './modal.scss';

export default class Modal extends Component {
    static initSelector: string = '.modal';

    openButton: NodeList;
    parent: HTMLElement;
    closeButton: HTMLElement;
    applyButton: HTMLElement;
    cancelButton: HTMLElement;
    container: HTMLElement;
    header: HTMLElement;
    hasContainer: boolean;
    inner: HTMLElement;
    keyboardHandler: () => void;

    constructor(target: HTMLElement) {
        super(target);

        this.hasContainer = false;
        this.parent = this.element.parentElement;
        this.header = this.element.querySelector('.modal__header');
        this.openButton = document.querySelectorAll('a[href="#' + this.element.id + '"][data-js="open-modal"');
        this.container = document.createElement('div');
        this.container.classList.add('modal-container');
        this.inner = document.createElement('div');
        this.inner.classList.add('modal-container__inner');
        this.closeButton = document.createElement('button');
        this.closeButton.classList.add('modal__close');
        this.closeButton.innerHTML = Icon.render('close', 'modal__close-icon');
        this.applyButton = this.element.querySelector('.modal__apply');
        this.cancelButton = this.element.querySelector('.modal__button--cancel');

        this.keyboardHandler = this.keyboard.bind(this);

        this.openButton.forEach((link: HTMLLinkElement): void => {
            link.addEventListener('click', (event: MouseEvent): void => {
                event.preventDefault();
                this.open();
            });
        });

        if (this.element.classList.contains('modal--demo')) {
            this.open();
        }
    }

    bindEventHandlers(): void {
        this.container.addEventListener('modal.close', this.close.bind(this));
        this.container.addEventListener('click', (event: MouseEvent): void => {
            if (event.target === event.currentTarget || event.target === this.inner[0]) {
                event.preventDefault();

                this.close();
            }
        });

        this.closeButton.addEventListener('click', (event: MouseEvent): void => {
            event.preventDefault();

            this.element.dispatchEvent(new Event('modalClosed'));

            this.close();
        });

        if (this.applyButton) {
            this.applyButton.addEventListener('click', (event: MouseEvent): void => {
                // TODO maybe some apply logic as well?
                event.preventDefault();

                this.element.dispatchEvent(new Event('modalClosed'));

                this.close();
            });
        }

        if (this.cancelButton) {
            this.cancelButton.addEventListener('click', (event: MouseEvent): void => {
                event.preventDefault();

                this.close();
            });
        }
    }

    open(): void {
        this.closeAll();

        if (!this.hasContainer) {
            this.inner.append(this.element);

            if (this.element.id) {
                const existingModal: HTMLElement = document.getElementById(this.element.id);
                const modalContainer: HTMLElement | null = (existingModal ? existingModal.closest('.modal-container') : null);

                if (modalContainer?.parentNode) {
                    modalContainer.parentNode.removeChild(modalContainer);
                }
            }

            this.container.append(this.inner);
            if (this.header) {
                this.header.prepend(this.closeButton);
            }

            document.body.append(this.container);

            this.bindEventHandlers();
            this.hasContainer = true;
        }

        this.container.classList.add('is-visible');

        Helpers.disableScroll();

        if (this.element.classList.contains('modal--qr')) {
            const qrScanner: HTMLElement = this.element.querySelector('.qr-scanner');

            if (qrScanner) {
                new QrScanner(qrScanner);
            }
        }

        document.addEventListener('keyup', this.keyboardHandler);
    }

    close(): void {
        this.container.classList.remove('is-visible');

        if (this.element.classList.contains('modal--qr')) {
            const stopEvent: CustomEvent = new CustomEvent('stopScanner');

            document.dispatchEvent(stopEvent);
        }

        Helpers.enableScroll();

        document.removeEventListener('keyup', this.keyboardHandler);
    }

    closeAll(): void {
        document.querySelectorAll('.modal-container').forEach((element: HTMLElement) => {
            const modalElement: HTMLElement = element.querySelector('.modal');

            element.classList.remove('is-visible');

            if (modalElement.classList.contains('modal--qr')) {
                const stopEvent: CustomEvent = new CustomEvent('stopScanner');

                document.dispatchEvent(stopEvent);
            }
        });
    }

    keyboard(event: KeyboardEvent): void {
        if (event.key === 'Esc' || event.key === 'Escape') {
            this.close();
        }
    }
}
